<div class="button-container">
  <button (click)="navigate()" class="apply-button">
    <div class="text-container">
      <span class="default-text">{{ defaultText }}</span>
      <span class="hover-text">{{ hoverText }}</span>
    </div>
  </button>
  <p class="places-counter" [class.dark]="darkCounter">{{ placesCount }}/{{ totalPlaces }} Plätze vergeben</p>
</div> 